module.exports = __webpack_public_path__ + "static/media/barcard-text-logo.d505c99b.svg";